export type League = "Bronze" | "Silver" | "Gold" | "Platinum" | "Diamond" | "Master" | "Champion";

/** Mirrors the documented account league thresholds without affecting match physics. */
export function leagueForRating(rating: number): League {
  if (!Number.isFinite(rating)) throw new TypeError("rating must be finite");
  if (rating >= 2_500) return "Champion";
  if (rating >= 2_250) return "Master";
  if (rating >= 2_000) return "Diamond";
  if (rating >= 1_750) return "Platinum";
  if (rating >= 1_500) return "Gold";
  if (rating >= 1_250) return "Silver";
  return "Bronze";
}
